module.exports = __webpack_public_path__ + "img/couples_04_V.7cc94fd5.webp";